<template>
	<div class="page-with-top-bar">
		<section>
			<div class="mt-4">
				<b-tabs type="is-boxed" v-model="mainActiveTab">
					<b-tab-item>
						<template slot="header">
						<b-icon pack="fas" icon="wrench"></b-icon>
						<span> {{ $t('customfields') }} </span>
						</template>
						<customfields
							ref="custom_fields_manual"
							:projectId="projectId"
							:entity_type="'project_templates'"
							option='customfields'
						></customfields>
					</b-tab-item>

					<b-tab-item>
						<template slot="header">
						<b-icon pack="fas" icon="file-import"></b-icon>
						<span>{{ $t('import_customfields') }}</span>
						</template>
						<div>
							<importEntities
								ref="import_customfields"
								:company-id="company.id"
								:entity-type="'customfields'"
								:can-overwrite="true"
								@success="customFieldsImportSuccess"
							></importEntities>
						</div>
					</b-tab-item>
				</b-tabs>
			</div>
		</section>
	</div>
</template>

<script>

	import {mapGetters} from "vuex";
	import customfields from "./customfields.vue";
	import importEntities from "../../../components/import-entities";

	export default {
		middleware: "auth",
		title: "customfields_page_title",
		menuOption: "0-9",
		components: {
			customfields,
			importEntities,
		},

		data: () => ({
			mainActiveTab: 0,
		}),

		computed: {
			projectId() {
				return parseInt(this.$route.params.project_id);
			},
			...mapGetters({
				company: "app/company",
			}),
		},

		methods: {
			customFieldsImportSuccess() {
				this.$refs.custom_fields_manual.getCustomfields();
			},
		}
	}

</script>
